import { useTheme } from "@hooks/use-theme";
import { Tooltip } from "./tooltip.component";
import { type TooltipProps } from "./tooltip.interface";

export const TooltipFactory = (props: TooltipProps) => {
	const { TooltipComponent } = useTheme();

	return TooltipComponent ? <TooltipComponent {...props} /> : <Tooltip {...props} />;
};
